import React from 'react';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: "Sarah & Mike",
      location: "New York, USA",
      review: "Traveze made our honeymoon absolutely perfect! The AI understood exactly what we were looking for and created an amazing itinerary through Europe. Every detail was perfectly planned.",
      rating: 5
    },
    {
      name: "James Chen",
      location: "Singapore",
      review: "As a business traveler, I appreciate how Traveze optimizes my trips. The AI suggestions for local experiences during my work trips have opened up a whole new world of possibilities.",
      rating: 5
    },
    {
      name: "Lisa Thompson",
      location: "Sydney, Australia",
      review: "I was skeptical about AI travel planning, but Traveze exceeded all my expectations. The personalized recommendations were spot-on, and I discovered hidden gems I never would have found otherwise.",
      rating: 5
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What Our Travelers Say</h2>
          <p className="section-subtitle">
            Real experiences from real travelers who trusted Traveze with their adventures
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>
              <p className="testimonial-review">"{testimonial.review}"</p>
              <div className="testimonial-author">
                <h4 className="testimonial-name">{testimonial.name}</h4>
                <p className="testimonial-location">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 